import { arrivalPortMap } from "../../Pages/Campaigns/data";
import { useLocation } from "react-router-dom";

export const usePortDependOnSystem = () => {
  const { pathname } = useLocation();
  const system = pathname.split("/")[2];
  
  const port = arrivalPortMap[system];

  return port;
};
